

















import { defineComponent } from "@vue/composition-api";
import { getElement } from "@/lib/elementHelpers";

export default defineComponent({
  name: "BaseSwitch",
  props: {
    label: { type: String, default: "" },
    name: { type: String, default: "" },
    value: { type: Boolean, required: true },
    disabled: { type: Boolean, default: false },
    hint: { type: String, default: "" },
  },
  model: {
    event: "input",
    prop: "value",
  },
  methods: {
    click() {
      (getElement(this.$refs.checkbox) as HTMLInputElement).click();
    },
  },
});
